// extracted by mini-css-extract-plugin
export default {"button":"PersonalDetails_button__7vpfY","divider":"PersonalDetails_divider__j9dhM"};